





export const isIptal = (iptal: string) => {
    return iptal === 'E' ? true : false
}

export enum DuyuruIslemEnum {
    Edit = 1,
    Detail = 2
}